import { SUPPORTED_LOCALES } from '../../../../../modules/i18n/config'
import { purposeItems } from '../content'
import {
  ageItems,
  companyTypeItems,
  experienceItems,
  genderItems,
  intimacyItems,
  pronunciationItems,
  relationshipItems,
  toneItems,
} from './content'

// type Locale = 'ko' | 'en' | 'ja'

export type TLocale = (typeof SUPPORTED_LOCALES)[number]

const getLocalizedTitle = (items: any[], id: number, locale: TLocale = 'en'): string | undefined => {
  const item = items.find((x) => x.id === id)
  if (!item) return undefined

  switch (locale) {
    case 'ko':
      return item.title
    case 'ja':
      return item.title_ja
    case 'en':
    default:
      return item.title_en
  }
}

const getLocalizedName = (
  items: { id: number; value: string; value_en?: string; value_ja?: string }[],
  id: number,
  locale: TLocale = 'en'
): string | undefined => {
  const item = items.find((x) => x.id === id)
  if (!item) return undefined

  switch (locale) {
    case 'ko':
      return item.value
    case 'ja':
      return item.value_ja
    case 'en':
    default:
      return item.value_en
  }
}

export const getKey = (scope, id) => {
  if (scope === 'purpose') {
    return purposeItems.find((x) => x.id === id).key
  }
}

export const getJobCategoryName = (items: any[], id: number, locale: TLocale) => getLocalizedTitle(items, id, locale)

export const getCompanyTypeName = (id: number, locale: TLocale) => getLocalizedName(companyTypeItems, id, locale)

export const getExperienceDurationName = (id: number, locale: TLocale) => getLocalizedName(experienceItems, id, locale)

export const getAgeName = (id: number, locale: TLocale) => getLocalizedName(ageItems, id, locale)

export const getToneName = (id: number, locale: TLocale) => getLocalizedName(toneItems, id, locale)

export const getRelationshipName = (id: number, locale: TLocale) => getLocalizedName(relationshipItems, id, locale)

export const getIntimacyName = (id: number, locale: TLocale) => getLocalizedName(intimacyItems, id, locale)

export const getPronunciationName = (id: number, locale: TLocale) => getLocalizedName(pronunciationItems, id, locale)

export const getGenderName = (id: number, locale: TLocale) => getLocalizedName(genderItems, id, locale)
